import { createSelector } from 'reselect'
import getCanRedeemTransferLoyaltyBenefit from './getCanRedeemTransferLoyaltyBenefit'
import getCanRedeemLoungePassLoyaltyBenefit from './getCanRedeemLoungePassLoyaltyBenefit'
import getCanRedeemStayUpgradeLoyaltyBenefit from './getCanRedeemStayUpgradeLoyaltyBenefit'

const getCanRedeemCheckoutLoyaltyBenefits = createSelector(
  (state: App.State) => getCanRedeemTransferLoyaltyBenefit(state),
  (state: App.State) => getCanRedeemLoungePassLoyaltyBenefit(state),
  (state: App.State) => getCanRedeemStayUpgradeLoyaltyBenefit(state),
  (canRedeemTransfers, canRedeemLoungePasses, canRedeemRoomUpgradeLoyaltyBenefit): boolean => {
    return canRedeemLoungePasses || canRedeemTransfers || canRedeemRoomUpgradeLoyaltyBenefit
  },
)

export default getCanRedeemCheckoutLoyaltyBenefits
